import { __awaiter, __decorate, __extends, __generator } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import NavPanel from '@/components/common/NavPanel.vue';
import { PageService } from '@/views/independent/import';
import { Toast } from 'vant';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.IntimacyCpInfo = {};
        return _this;
    }
    View.prototype.created = function () {
        if (!this.$route.query.targetId)
            return Toast('缺少targetId');
        this.getIntimacyCpInfo(this.$route.query.targetId);
        this.globalCommit('setting_pageJump', 1);
    };
    //  2024-01-23 15:05:07：前往亲密度说明页面
    View.prototype.Todescribe = function () {
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        var params = {
            action: 3,
            url: this.awlGlobalConfig.H5serviceUrl +
                '/nav/Intimacy' +
                '?navH=' +
                this.$route.query.navH +
                '&statusH=' +
                this.$route.query.statusH +
                '&token=' +
                this.$route.query.token,
            isImmersive: true,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    //  2024-01-23 14:58:57：滚动到当前等级
    View.prototype.scrollTo = function () {
        var idName = '#item_leve_';
        //  2024-01-23 15:16:36：指定元素
        var dom = document.querySelector(idName + this.IntimacyCpInfo.nowLevel);
        //  2024-01-23 15:16:49：滚动容器
        var dom_box = document.querySelector('.leve');
        if (dom && dom_box) {
            //  2024-01-23 15:15:05：获取到元素的位置信息
            var left = dom.getBoundingClientRect().left;
            //  2024-01-23 15:15:17：开启滚动
            var nowLeft = left - 16;
            dom_box.scrollTo({
                left: nowLeft,
                behavior: 'smooth',
            });
        }
    };
    //  2024-01-23 10:41:24：计算进度条
    View.prototype.computeProgress = function () {
        //  2024-01-23 10:41:36：向上取整
        if (!this.IntimacyCpInfo.degree)
            return 0;
        var num = this.IntimacyCpInfo.degree + this.IntimacyCpInfo.diffDegree;
        return Math.ceil((this.IntimacyCpInfo.degree / num) * 100);
    };
    //  2024-01-22 18:14:13：获取双方亲密度
    View.prototype.getIntimacyCpInfo = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, PageService.getIntimacyCpInfo({ targetId: id })];
                    case 1:
                        _a.IntimacyCpInfo = _b.sent();
                        this.$nextTick(function () {
                            _this.scrollTo();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    View = __decorate([
        Options({ components: { NavPanel: NavPanel } })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
